// filestack init  
let client = null;
// filestack init end 

function inputError(){
    let check = true;
    document.querySelectorAll('.product_calculator_main .ctm_fieald input').forEach((ele)=>{
        let val = Number(ele.value),
        min  = Number(ele.min),
        max = Number(ele.max);
        if(val == '' || val == null || typeof(val) == 'undefined' || val == 0){
            check = false;
            ele.classList.add('error');
            document.querySelector('.product__block.product__block--price').style.display = 'none';
            return false;
        }else{
            ele.value = val<min?min:val;
            ele.classList.remove('error');
        }
    });
    if(check) document.querySelector('.product__block.product__block--price').style.display = 'block';
    return check;
}

function getInputData(){
    let w = Number(document.querySelector('.product_calculator input#ctm_width').value),
     h = Number(document.querySelector('.product_calculator input#ctm_height').value),
     qty = Number(document.querySelector('.product_calculator input#ctm_quantity').value),
     i = w*h*qty,
     sF = Number((i/144).toFixed(2)),
     fixVal = Number(document.querySelector('#get_calc_data').dataset.fix),
     proId = document.querySelector('#get_calc_data').dataset.id,
     fOpt = document.querySelector('fieldset.product-form__input.product-form__input--button[data-index="1"] input:checked').value,
     rdNum = Math.floor((Math.random() * 10000));
     varTitle = `${w}X${h} / ${qty} - CUST${rdNum}`,
     proImg = document.querySelector('.product_calculator_main').dataset.img,
     proUrl = document.querySelector('.product_calculator_main').dataset.url,
     proTitle = document.querySelector('.product_calculator_main').dataset.title;
     return {
        width:w,
        height:h,
        quantity:qty,
        inches:i,
        sqFt:sF,
        fixVal,
        proId,
        varTitle,
        proImg,
        proUrl,
        proTitle
     }
}

function waitForFilestack(callback) {
    if (typeof filestack !== 'undefined') {
        console.log("Filestack SDK ready");
        callback();
    } else {
        console.log("Filestack SDK not load ");
        setTimeout(() => waitForFilestack(callback), 500); 
    }
}

function updatePoUi(fileName, fileUrl) {
    document.querySelectorAll('.po-upload-form').forEach((form) => {
        const btnSpan = form.querySelector('.po-upload-btn span');
        const nameInput = form.querySelector('.po-name-input, #po-name');
        const linkInput = form.querySelector('.po-file-link-input, #po-file-link');
        let display = form.querySelector('.po-file-display');

        if (nameInput) nameInput.value = fileName || '';
        if (linkInput) linkInput.value = fileUrl || '';

        if (btnSpan) {
            btnSpan.textContent = fileName ? 'Replace PO' : 'Upload PO (Optional)';
        }

        if (!display) {
            display = document.createElement('div');
            display.className = 'po-file-display';
            form.appendChild(display);
        }

        if (fileName && fileUrl) {
            display.hidden = false;
            display.innerHTML = `Uploaded: <a href="${fileUrl}" target="_blank" rel="noopener">${escapeHtml(fileName)}</a>`;
        } else if (fileName) {
            display.hidden = false;
            display.textContent = `Uploaded: ${fileName}`;
        } else {
            display.hidden = true;
            display.textContent = '';
        }
    });
}

function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
}


function uploadPO(btn) {
    btn.classList.add('btn--loading');

    const span = btn.querySelector('span');

    waitForFilestack(() => {
        let client;
        try {
            client = filestack.init('ATJ80K3JRdWCR0xJl5rkzz');
        } catch (error) {
            console.error('Filestack.init fail:', error);
            btn.classList.remove('btn--loading');
            if (span) span.textContent = 'Init Error!';
            return;
        }

        const pickerOptions = {
            accept: ['.jpg', '.png', '.pdf'],
            maxFiles: 1,
            onUploadDone: async (res) => {
                if (!(res.filesUploaded && res.filesUploaded.length > 0)) {
                    console.error('PO upload failed');
                    btn.classList.remove('btn--loading');
                    if (span) span.textContent = 'Upload Failed!';
                    return;
                }

                const uploadedFile = res.filesUploaded[0];
                let fileUrl = uploadedFile.url;

                if (!fileUrl && uploadedFile.handle) {
                    fileUrl = `https://cdn.filestackcontent.com/${uploadedFile.handle}`;
                }

                const fileName = uploadedFile.filename || '';

                if (!fileUrl) {
                    console.error('No file URL returned from Filestack', uploadedFile);
                    btn.classList.remove('btn--loading');
                    if (span) span.textContent = 'Upload Failed!';
                    return;
                }

                console.log('Uploaded PO file', uploadedFile);

                const poNameInput = document.getElementById('po-name');
                const poFileLinkInput = document.getElementById('po-file-link');

                if (poNameInput) poNameInput.value = fileName;
                if (poFileLinkInput) poFileLinkInput.value = fileUrl;

                try {
                    const response = await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            attributes: {
                                poName: fileName,
                                poFileLink: fileUrl
                            }
                        })
                    });

                    if (!response.ok) {
                        throw new Error(`Cart update failed: ${response.status}`);
                    }

                    const data = await response.json();
                    console.log('Cart updated with PO attributes:', data);

                    updatePoUi(fileName, fileUrl);
                } catch (error) {
                    console.error('Cart attribute update failed:', error);
                    if (span) span.textContent = 'Save Failed!';
                }

                btn.classList.remove('btn--loading');
            }
        };

        try {
          const picker = client.picker(pickerOptions);
picker.open().then(() => {
    btn.classList.remove('btn--loading');
});
        } catch (error) {
            console.error('Picker open error:', error);
            if (span) span.textContent = 'Error! Retry';
            btn.classList.remove('btn--loading');
        }
    });
}

function uploadImage(btn) {
    console.log(btn);
    btn.classList.add('btn--loading');
    waitForFilestack(() => {
        let client;
        try {
            client = filestack.init('ATJ80K3JRdWCR0xJl5rkzz');
            console.log("Filestack client initialize !");
        } catch (error) {
            console.error("Filestack.init fail : ", error);
            btn.querySelector('span').textContent = 'Init Error!';
            btn.classList.remove('btn--loading');
            return;
        }
 
        const pickerOptions = {
            // this is new added
            onUploadDone: (res) => {
                // console.log
                // console.log('Upload response:', res); // Debug log
                debugger
                if (res.filesUploaded && res.filesUploaded.length > 0) {
                    const uploadedFile = res.filesUploaded[0];
                    // console.log('=== FILE OBJECT ===', uploadedFile);
                    // console.log('Filestack filename:', uploadedFile.filename);
                    // console.log('Filestack originalPath:', uploadedFile.originalPath);
                    let fileUrl = uploadedFile.url;
                    if (!fileUrl && uploadedFile.handle) {
                        fileUrl = `https://cdn.filestackcontent.com/${uploadedFile.handle}`;
                    }
                    const fileName = uploadedFile.filename;
                    
                    const isBack = btn.classList.contains('back-img-sticker');
                    const linkInputName = isBack ? 'properties[backFileLink]' : 'properties[fileLink]';
                    const fileNameInputName = isBack ? 'properties[backFileName]' : 'properties[fileName]';
                    
                    const linkInput = document.querySelector(`[name="${linkInputName}"]`);
                    if (linkInput) {
                        linkInput.value = fileUrl;
                        const fileNameInput = document.querySelector(`[name="${fileNameInputName}"]`);
                        fileNameInput.value = fileName;
                    } else {
                        let input = document.createElement('input');
                        let inputFile = document.createElement('input');
                        input.type = 'hidden';
                        inputFile.type = 'hidden';
                        input.name = linkInputName;
                        inputFile.name = fileNameInputName;
                        input.value = fileUrl;
                        inputFile.value = fileName;
                        const form = document.querySelector('.product__block.product__block--buy_buttons [action="/cart/add"]');
                        if (form) {
                            form.appendChild(input);
                            form.appendChild(inputFile);
                        } else {
                            console.error('Form not found');
                        }
                    }
                    
                    btn.querySelector('span').textContent = 'Uploaded!';
                    btn.classList.remove('btn--loading');
                } else {
                    console.error("Upload fail!");
                    btn.querySelector('span').textContent = 'Upload Failed!';
                    btn.classList.remove('btn--loading');
                }
            }
        };

        try {
            //  console.log('LOCAL PICKER OPTIONS', pickerOptions);
            const picker = client.picker(pickerOptions);
            picker.open().then(()=>{setTimeout(()=>{
              btn.classList.remove('btn--loading');
            },1000)});
            console.log("Picker open ");
        } catch (error) {
            console.error("Picker open error: ", error);
            btn.querySelector('span').textContent = 'Error! Retry';
            btn.classList.remove('btn--loading');
        }
    });
}

if(document.querySelectorAll('.upload_btn')){
    document.querySelectorAll('.upload_btn').forEach((ele)=>{
        ele.addEventListener('click',function(){
            uploadImage(this);
        });
    });
}

document.querySelectorAll('.po-upload-btn').forEach((ele) => {
    ele.addEventListener('click', function () {
        uploadPO(this);
    });
});


document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);

  const fileLink = params.get("fileLink");
  const fileName = params.get("fileName");

  const backFileLink = params.get("backFileLink");
  const backFileName = params.get("backFileName");

  const isReorder = params.get("_reOrder") === "true";

     const finish = params.get("finish");
     const magnetShape = params.get("magnetShape");
     const peel = params.get("peel");
     const shape = params.get("shape");
     const surface = params.get("surface");
     const clearorwhite = params.get("clearorwhite");
     const printmethod = params.get("printmethod");
     const surfacePrintMethod = params.get("surfacePrintMethod");
     const staticClingShape = params.get("staticClingShape");
     const ordernotes = params.get("ordernotes");

    function preselectRadio(name, value) {
        if (!value) return;

        const input = document.querySelector(
            `input[type="radio"][name="properties[${name}]"][value="${CSS.escape(value)}"]`
        );

        if (input) {
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        }
   }
    if (isReorder) {
        preselectRadio("finish", finish);
        preselectRadio("magnetShape", magnetShape);
        preselectRadio("peel", peel);
        preselectRadio("shape", shape);
        preselectRadio("surface", surface);
        preselectRadio("clearorwhite", clearorwhite);
        preselectRadio("printmethod", printmethod);
        preselectRadio("surfacePrintMethod", surfacePrintMethod);
        preselectRadio("staticClingShape", staticClingShape);
    
        function disableOptionRadios(names = []) {
            names.forEach((name) => {
                const radios = document.querySelectorAll(
                `input[type="radio"][name="properties[${name}]"]`
                );
                radios.forEach((radio) => {
                radio.classList.add("is-disabled");
                const label = document.querySelector(`label[for="${radio.id}"]`);
                if (label) {
                    label.classList.add("is-disabled");
                }
                });
            });
         }
        disableOptionRadios([
            "finish",
            "magnetShape",
            "peel",
            "shape",
            "surface",
            "clearorwhite",
            "printmethod",
            "surfacePrintMethod",
            "staticClingShape"
            ]);
    }

    if (isReorder && ordernotes) {
        const noteInput = document.querySelector(
            '[name="properties[ordernotes]"]'
        );

        if (noteInput) {
            noteInput.value = ordernotes;
             noteInput.readOnly = true;
            noteInput.classList.add("is-disabled");
        }
    }

  const form = document.querySelector(
    '.product__block.product__block--buy_buttons [action="/cart/add"]'
  );

  if (!form) return;

  function ensureHiddenInput(name, value) {
    if (!value) return;

    let input = form.querySelector(`[name="${name}"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  // 🔹 FRONT FILE
  ensureHiddenInput("properties[fileLink]", fileLink);
  ensureHiddenInput("properties[fileName]", fileName);

  // 🔹 BACK FILE
  ensureHiddenInput("properties[backFileLink]", backFileLink);
  ensureHiddenInput("properties[backFileName]", backFileName);

  // _reOrder 
   if (isReorder) {
    ensureHiddenInput("properties[_reOrder]", "true");
  }
  /* ===============================
     🔁 REORDER MODE HANDLING
     =============================== */

  if (isReorder) {
   const widthInput = document.getElementById("ctm_width");
   const heightInput = document.getElementById("ctm_height");
    const stickerFieldset = document.querySelector('.product-form__input.sticker-size');
    if (widthInput) {
      widthInput.readOnly = true;
      widthInput.classList.add("is-disabled");
    }

    if (heightInput) {
      heightInput.readOnly = true;
      heightInput.classList.add("is-disabled");
    }
    // 🔔 Add info message above product__info-container
     const productInfoContainerMain = document.querySelector(".product__info-container");
    const productInfoContainer = document.querySelector(".product__blocks__main");
    if (productInfoContainer && !document.querySelector(".reorder-info")) {
        productInfoContainerMain.classList.add('re-order');
      const info = document.createElement("h4");
      info.className = "reorder-info";
      info.textContent =
        "This is a reorder. You can update the quantity only.";

      productInfoContainer.parentNode.insertBefore(info, productInfoContainer);
    }
    if (stickerFieldset) {
        const inputs = stickerFieldset.querySelectorAll("input[type='radio']");
        const labels = stickerFieldset.querySelectorAll("label");
        inputs.forEach(input => {
        input.disabled = true; // ✅ radio ke liye correct
        input.classList.add("is-disabled");
        });

        labels.forEach(label => {
        label.classList.add("is-disabled");
        });
        // const checkedInput = stickerFieldset.querySelector("input[type='radio']:checked");
        // if (checkedInput && checkedInput.value !== "CUSTOM SIZES") {
        //     console.log(checkedInput.value)
        // const stickerWidth = checkedInput.value.split('x')[0];
        // const stickerHeight = checkedInput.value.split('x')[1];
        // document.querySelector('[name="properties[width]"]').value = stickerWidth;
        // document.querySelector('[name="properties[height]"]').value = stickerHeight;
        // document.querySelector('variant-selects').style.display = 'none';
        // document.querySelector('.product_calculator_main').classList.add('active');
        // }
    }
    
  }
});





// ✅ fixed version
function moneyFormate(price) {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    }).format(price);
}

// Parse money from formatted text (e.g., '$44.80' -> 44.80)
function parseMoney(text) {
    return parseFloat(text.replace(/[^\d.-]/g, '')) || 0;
}

// Format function
function formatMoney(amount) {
    return Shopify?.formatMoney ? Shopify.formatMoney(amount * 100) : `$${amount.toFixed(2)}`;
}

// B2B Dynamic Price Updater
(async function() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initB2BPrices);
    } else {
        initB2BPrices();
    }

    function initB2BPrices() {
        const b2bData = window.B2BData;
        console.log('B2B Data Passed:', b2bData);
        if (!b2bData || !b2bData.companyId || !b2bData.productId || !b2bData.variants) {
            console.log('No B2B data, skipping price update');
            return;
        }
        console.log('Initializing B2B Price Update...');  // Debug
        updateRetailPrice(b2bData);
    }

    async function updateRetailPrice(b2bData) {
        const priceBlock = document.querySelector('.product__block.product__block--price');
        if (!priceBlock) {
            console.warn('Price block not found');
            return;
        }

        const companyId = b2bData.companyId;
        const productId = b2bData.productId;
        console.log('companyId:', companyId);
        console.log('productId:', productId);
        try {
            // API Call (once, discount % fixed for product)
            const response = await fetch('https://stickerbeat-app-7oqw8.ondigitalocean.app/api/catlog-data', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    companyId: companyId, 
                    productId: productId 
                })
            });

            if (!response.ok) throw new Error('API failed');

            const apiData = await response.json();
            console.log('API Response:', apiData);  // Debug

            // Find relevant catalog for the product
            let discountPercent = 0;
            const catalogs = apiData.data.data?.company?.locations?.nodes?.[0]?.catalogs?.nodes || [];
            const productGid = `gid://shopify/Product/${productId}`;
            
            for (const catalog of catalogs) {
                const products = catalog.publication?.products?.nodes || [];
                if (products.some(product => product.id === productGid)) {
                    const adjustment = catalog.priceList?.parent?.adjustment;
                    if (adjustment?.type === 'PERCENTAGE_DECREASE') {
                        discountPercent = adjustment.value;
                        console.log(discountPercent);
                    }
                    break;  // First matching catalog
                }
            }
            
            console.log('discountPercent:', discountPercent);

            // Make discountPercent global for use in calculatValue
            window.discountPercent = discountPercent;

            // Multiplier calculate (only if discount > 0)
            const multiplier = discountPercent > 0 ? 100 / (100 - discountPercent) : 1;

            // Get variant input
            const variantInput = document.querySelector('input[name="id"]');
            if (!variantInput) {
                console.warn('Variant input not found');
                return;
            }

            let isUpdating = false;

            // Function to update price based on current variant
            function updatePrice() {
                if (isUpdating) return;
                isUpdating = true;

                // Fresh selection of spans
                const retailSpan = priceBlock.querySelector('.retail_price');
                const discountSpan = priceBlock.querySelector('.retail_price_discount');
                const discountedSpan = priceBlock.querySelector('.f-price-item.f-price-item--regular');
                if (!retailSpan || !discountedSpan) {
                    console.warn('Required spans not found');
                    isUpdating = false;
                    return;
                }

                const disc = parseMoney(discountedSpan.textContent);
                if (disc === 0) {
                    console.warn('No discounted price found');
                    isUpdating = false;
                    return;
                }

                let retailAmount = disc * multiplier;
                console.log('discountedPrice:', disc);
                console.log('retailAmount:', retailAmount);

                // Currency rate adjust (if needed)
                if (Shopify?.currency?.rate && Shopify.currency.rate !== 1) {
                    retailAmount = Math.ceil(retailAmount)
                }

                // Update spans
                const formattedPrice = formatMoney(retailAmount);
                 if (discountPercent > 0) {
                retailSpan.textContent = formattedPrice;
                 }
                console.log('Span updated:', formattedPrice);

                // Update discount span if applicable
                if (discountSpan) {
                    if (discountPercent > 0) {
                        discountSpan.textContent = `${discountPercent}% discount`;
                    } 
                }

                setTimeout(() => { isUpdating = false; }, 200);
            }

            // Initial update
            setTimeout(updatePrice, 100);

            // Listen for variant changes
            variantInput.addEventListener('change', () => {
                setTimeout(updatePrice, 300);  // Delay to let theme update the block first
            });

            // MutationObserver on price block to catch refreshes
            const observer = new MutationObserver((mutations) => {
                if (!isUpdating) {
                    let shouldUpdate = false;
                    for (const mutation of mutations) {
                        if (mutation.type === 'childList' || mutation.type === 'characterData') {
                            shouldUpdate = true;
                            break;
                        }
                    }
                    if (shouldUpdate) {
                        setTimeout(updatePrice, 150);
                    }
                }
            });
            observer.observe(priceBlock, { 
                childList: true, 
                subtree: true, 
                characterData: true 
            });

            console.log(`Success: ${discountPercent}% discount applied. Variant listener and observer set up.`);

        } catch (error) {
            console.error('API Error, Fallback:', error);
            // Fallback: No change, keep discounted price and empty discount
        }
    }
})();


// ✅ update both discounted + retail price
function setHtml(priceWithCurrancy, rawPrice){
    document.querySelector('.product__block.product__block--price .f-price-item.f-price-item--regular')
        .innerHTML = priceWithCurrancy;
    // Retail will be updated via observer
}

function calculatValue(){
    let {sqFt,fixVal,varTitle} = getInputData(),
    rate = 0,
    optLength = document.querySelectorAll('#get_calc_data option').length,
    lastOpt = document.querySelectorAll('#get_calc_data option')[optLength-1];
    document.querySelectorAll('#get_calc_data option').forEach((ele)=>{
        let min = ele.dataset.min,max = ele.dataset.max;
        if(min <= sqFt && max >= sqFt){
            rate = Number(ele.value); 
            return false;
        } 
    });
    if(lastOpt.dataset.max < sqFt)rate = Number(lastOpt.value);
    let price = (rate*sqFt)+(fixVal);
    if(document.querySelector('.product_calculator_main').classList.contains('its-wholsale-ctm') && typeof window.discountPercent !== 'undefined'){
        let oneParsent = price/100,
        priceDiscount = oneParsent*window.discountPercent;
       
        price = price - priceDiscount;
    }
    let priceWithCurrancy = moneyFormate(price*Number(Shopify.currency.rate));


    return{
        rate,
        price:price*Number(Shopify.currency.rate),
        priceWithCurrancy,
        varTitle
    }
}

const useDebounce = (func, delay) => {
    let timeout = null;   
    return (...args) => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

document.querySelectorAll('.product_calculator_main .ctm_fieald input').forEach((ele) => {
    ele.addEventListener('input', useDebounce(validate_and_show_price, 1500));
});

// ✅ now updates both discounted + retail prices
function validate_and_show_price() {  
    let noError = inputError();
    if (noError) {
        let { price, priceWithCurrancy } = calculatValue();
        setHtml(priceWithCurrancy, price);
    }
}

async function customVariantAdd(proForm,config){
    let noError = inputError();
    if(noError){
        proForm.submitButtonElement.setAttribute('aria-disabled', 'true');
        proForm.submitButtonElement.classList.add('btn--loading');
        let data = calculatValue();
        console.log(data);
        return data;

        // This code is not usable
        let newVariant = await sendData(data),
        cartData = await getCart();
        if(newVariant.message == 'Success'){
            let inputObj = getInputData();
            inputObj = {
                proImg,
                varTitle,
                price:data.price,
                id:newVariant.data,
                proTitle,
                proUrl,
                total_price:cartData.total_price/100,
                currency:cartData.currency
            }
            localStorage.setItem('cart_variant',JSON.stringify(inputObj));
            proForm.formData.delete('id');
            proForm.formData.append('id',newVariant.data[0]);
            config.body = proForm.formData;
            proForm.handleFormSubmission(config);
            setTimeout(()=>{
                localStorage.removeItem('cart_variant',JSON.stringify(inputObj));
            },15000);
        }else{
            proForm.submitButtonElement.classList.remove('btn--loading');
            proForm.submitButtonElement.removeAttribute('aria-disabled');

            if (!proForm.hasError) {
                proForm.submitButtonElement.removeAttribute('aria-disabled');
            }
        }
    }else{
        let scrl = document.querySelector('.product_calculator').scrollWidth;
        scroll(0,scrl);
    }
}

async function sendData(data,checkData){
    let {price} = data,
    reqJson = checkData?data:[{proTitle:getInputData().varTitle,proId:getInputData().proId,price}];
    const varData = await fetch(`https://stickerbeat-app-7oqw8.ondigitalocean.app/api/createVarient`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(reqJson)
    })
    .then((response) => response.json())
    .then((res) => {
        return res;
    })
    .catch((error) => {
        console.error("Error:", error);
        return{
            message:"Error",
            error:error
        }
    });
    return varData;
}

function updateCtmCart(){
    return; // new modification
    let cartCtmData = JSON.parse(localStorage.getItem('cart_variant')),
    ctmCartTotal = (cartCtmData.total_price)+cartCtmData.price,
    ctmCartVarTitle = cartCtmData.varTitle.replace(' / ',', '),
    cartLi = document.querySelector('.cart-item[data-variant-id="'+cartCtmData.id+'"]'),
    srcSet = `${cartCtmData.proImg}&width=80 80w, ${cartCtmData.proImg}&width=100 100w, ${cartCtmData.proImg}&width=160 160w, ${cartCtmData.proImg}&width=200 200w`;
    if(cartLi.querySelector('.ctm_cart_img_ele')){
        cartLi.querySelector('.ctm_cart_img_ele').href = cartCtmData.proUrl;
        cartLi.querySelector('.ctm_cart_img_ele img').src = cartCtmData.proImg;
        cartLi.querySelector('.ctm_cart_img_ele img').setAttribute('srcset',srcSet);
        cartLi.querySelector('.cart-item__product .cart-item__title').setAttribute('href',cartCtmData.proUrl);
        cartLi.querySelector('.cart-item__product .cart-item__title').textContent = cartCtmData.proTitle+'test';
        cartLi.querySelector('.cart-item__product .ctm_cart_price').textContent = moneyFormate(cartCtmData.price);
        cartLi.querySelector('.cart-item__product .ctm_cart_opt_1').textContent = ctmCartVarTitle;
        document.querySelector('.totals__subtotal-value').textContent = moneyFormate(ctmCartTotal)+' '+cartCtmData.currency;
    }
}

async function getCart() {
    try {
        const response = await fetch("/cart.js");
        if (!response.ok)
            throw new Error("Failed to fetch cart data");
        return await response.json()
    } catch (error) {
        return console.error("Error fetching cart data:", error),
        null
    }
}